/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AccountUpdateViewModel {
  id?: string;
  type?: string | null;
  note?: string | null;
  status?: string | null;
  uploadDate?: string;
  content?: string | null;
  patientId?: string | null;
  visitId?: string | null;
  procedureTransactionId?: string | null;
  visitNumber?: number;
  procedureCode?: string | null;
  createdBy?: string | null;
  createdDate?: string;
}
